// libraries
import { getAllRoutes } from '@makemydeal/dr-activities-audit-log';
import { NavigationItemStatus } from '@makemydeal/dr-activities-shared';

// interfaces/types
import type { IFlowConfig } from '../../flowMasterInterfaces';

// components
import AuditLog from './components/AuditLogContainer';

// consts/enums
import { APP_NAME, AUDIT_LOG_ROUTE_ROOT } from './constants';

export const allRoutes = getAllRoutes(AUDIT_LOG_ROUTE_ROOT);

// istanbul ignore next
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noopReducer = () => {};

/* this activity won't appear on the dr-activities-dashboard card list,
 * so including the bare minimum inputs to satisfy the interface
 */
export const auditLogConfiguration: IFlowConfig<any> = {
    name: APP_NAME,
    navCard: {
        label: 'Audit Log',
        icon: 'auditlog',
        cardId: 'dr-sp-audit-log'
    },
    showCardSelector: () => false,
    isCompleteSelector: () => false,
    routingComponent: AuditLog,
    defaultRoute: allRoutes.root,
    routes: [...Object.keys(allRoutes).map((routeName) => allRoutes[routeName])],
    middleware: null,
    reducer: noopReducer, // audit-log doesn't have any of its own state
    isLocked: (_state: unknown) => false,
    dependsOnLeadFormCompletion: () => false,
    status: () => NavigationItemStatus.DEFAULT,
    isDisabled: () => false
};
